"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtalantaPlanitiaLab = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var AtalantaPlanitiaLab = (function (_super) {
    __extends(AtalantaPlanitiaLab, _super);
    function AtalantaPlanitiaLab() {
        return _super.call(this, {
            name: CardName_1.CardName.ATALANTA_PLANITIA_LAB,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.SCIENCE],
            cost: 10,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 3); }),
            metadata: {
                cardNumber: '216',
                description: 'Requires 3 science tags. Draw 2 cards.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.cards(2); }),
                victoryPoints: 2,
            },
        }) || this;
    }
    ;
    AtalantaPlanitiaLab.prototype.play = function (player) {
        player.drawCard(2);
        return undefined;
    };
    AtalantaPlanitiaLab.prototype.getVictoryPoints = function () {
        return 2;
    };
    return AtalantaPlanitiaLab;
}(Card_1.Card));
exports.AtalantaPlanitiaLab = AtalantaPlanitiaLab;
//# sourceMappingURL=AtalantaPlanitiaLab.js.map